<template>
  <div class="page-add">
    <div class="add-title">
      {{ addTitle }}
      <butn
        class="btn"
        btntype="primary"
        iconName="el-icon-arrow-left"
        title="返回"
        @click="goBack"
        ></butn
      >
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="130px"
      class="form"
      size="small"
      disabled
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="弹窗类型：" prop="bizType" required>
            <el-select
              class="form-select"
              v-model="ruleForm.bizType"
              placeholder="请选择弹窗类型"
              @change="changeBizType"
            >
              <el-option
                v-for="item in popupBiztypeList"
                :key="Number(item.paramKey)"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="弹窗标题：" prop="name">
            <el-input
              type="textarea"
              placeholder="请输入弹窗标题"
              v-model="ruleForm.name"
              maxlength="50"
              autosize
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="弹窗提醒时间：" prop="popupDate" required>
            <el-date-picker
              unlink-panels
              v-model="ruleForm.popupDate"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="dateChange"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.bizType == 1">
        <el-col :span="12">
          <el-form-item label="关联直播：" prop="bizId" required>
            <load-select
              class="form-select"
              v-model="ruleForm.bizId"
              dictLabel="name"
              dictValue="uuid"
              :data="liveRoomData"
              :page="liveRoomPage"
              :hasMore="liveRoomMore"
              :request="getLiveRoomData"
              placeholder="请选择关联直播（输入名称以搜索）"
              :defaultVal="ruleForm.bizName"
              :isInit="isLiveRoomInit"
              @change="liveRoomChange"
              @ChangeValue="changeLiveRoom"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col :span="12">
          <el-form-item label="关联课程预约：" prop="bizId" required>
            <load-select
              class="form-select"
              v-model="ruleForm.bizId"
              dictLabel="name"
              dictValue="uuid"
              :data="courseTicketData"
              :page="courseTicketPage"
              :hasMore="courseTicketMore"
              :request="getCourseTicketData"
              placeholder="请选择关联课程预约（输入名称以搜索）"
              :defaultVal="ruleForm.bizName"
              :isInit="isCourseTicketInit"
              @change="courseTicketChange"
              @ChangeValue="changeCourseTicket"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 演讲人 -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="演讲人：" prop="lecturerNamePost">
            <el-input
              placeholder="请输入演讲人"
              v-model="ruleForm.lecturerNamePost"
              type="textarea"
              autosize
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="课程开始时间：" prop="bizStartTime">
            <el-input
              placeholder="请输入课程开始时间"
              v-model="ruleForm.bizStartTime"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="是否启用倒计时：" required>
            <el-radio-group
              v-model="ruleForm.isCountdown"
              @input="changeCountDown"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.isCountdown == 1">
        <el-col :span="12">
          <el-form-item label="倒计时结束时间：" prop="countdownDate" required>
            <el-date-picker
              v-model="ruleForm.countdownDate"
              type="datetime"
              clearable
              placeholder="倒计时结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.isCountdown == 1">
        <el-col :span="12">
          <el-form-item
            class="form_item"
            label="倒计时提示文案："
            prop="countdownDesc"
          >
            <el-input
              class="text_left"
              placeholder="请输入倒计时提示文案"
              v-model="ruleForm.countdownDesc"
              maxlength="14"
            ></el-input>
            <div class="text_right">XX 时 XX 分 XX 秒</div>
            <el-col>
              <div class="tip_style">备注： { } 内的提示文案，可以标红显示</div>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="弹窗提醒范围：" required>
            <el-radio-group v-model="ruleForm.limitType">
              <el-radio :key="2" :label="2">{{
                `与授权用户列表一致（通过授权范围开放的用户，无法同步至干部之家，进行指定用户直播弹窗提醒。）`
              }}</el-radio>
              <el-radio v-if="isShowRange" :key="1" :label="1"
                >全部用户</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item style="text-align: center">
            <!-- <el-button @click="reset">重置</el-button>
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="onSubmit">提交</el-button> -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {
  getPopupInfo,
  getCourseTicketSelectPage,
  getLiveRoomSelectPage,
  updatePopupInfo,
  savePopupInfo,
} from "@/api/liveRoom";
import { getSysParamByTypes } from "@/api/sysParam";
import LoadSelect from "@/components/load-select/index.vue";
import rulesFactory from "@/utils/rules";
import butn from "@/components/button/index";
import { setItem, getItem } from "@/utils/storage";

export default {
  components: {
    LoadSelect,
    butn
  },
  data() {
    return {
      isShowRange: false,
      data: [],
      addTitle: "弹窗详情",
      ruleForm: {
        bizType: null,
        name: "",
        popupDate: null,
        bizId: "",
        lecturerNamePost: "",
        bizStartTime: "",
        isCountdown: null,
        bizName: "",
        countdownDate: "",
        countdownDesc: "距离 {倒计时时间} 预约开始还有",
        limitType: 2,
      },
      rules: {
        name: [
          { required: true, message: "请输入弹窗标题", trigger: "blur" },
          rulesFactory.size("最多输入50个字", 0, 50),
        ],
        popupDate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                callback(new Error("请选择弹窗提醒时间"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        bizId: [
          {
            required: true,
            message: "请选择",
            trigger: ["change", "blur"],
          },
        ],
        lecturerNamePost: [
          { required: true, message: "请输入演讲人", trigger: "blur" },
          rulesFactory.size("最多输入1000个字", 0, 1000),
        ],
        bizStartTime: [
          { required: true, message: "请输入课程开始时间", trigger: "blur" },
          rulesFactory.size("最多输入50个字", 0, 50),
        ],
        countdownDate: [
          { required: true, message: "请选择倒计时结束时间", trigger: "blur" },
        ],
        countdownDesc: [
          { required: true, message: "请输入倒计时提示文案", trigger: "blur" },
          rulesFactory.size("最多输入14个字", 0, 14),
        ],
      },
      resetForm: {},
      editFlag: false,
      publicData: [],
      liveRoomData: [],
      liveRoomMore: true,
      isLiveRoomInit: true,
      liveRoomPage: 1,
      courseTicketData: [],
      courseTicketMore: true,
      isCourseTicketInit: true,
      courseTicketPage: 1,
      popupBiztypeList: [],
      from: "edit",
    };
  },
  created() {
    let deptLevelCode = getItem("deptLevelCode");
    this.from = this.$route.query.from || "edit";
    this.isShowRange = deptLevelCode == "001";
    this.getSysParamByTypes(["IS_VALID", "POPUP_BIZ_TYPE"]);
    if (this.$route.query.id) {
      this.editFlag = true;
      const id = this.$route.query.id;
      // 处理编辑或者详情
      this.getPopupDetail(id);
    } else {
      this.editFlag = false;
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: "/gbzjConfig", query: { active: 2 } });
    },
    changeBizType(val) {
      if (!!val) {
        this.ruleForm.lecturerNamePost = "";
        this.ruleForm.bizStartTime = "";
      }
    },
    changeCountDown(val) {
      if (!!val) {
        this.ruleForm.countdownDesc = "距离 {倒计时时间} 预约开始还有";
      }
    },
    getLiveRoomData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getLiveRoomSelectPage({ page })
          .then(({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.liveRoomData = [...this.liveRoomData, ...data.records];
            } else {
              this.liveRoomData = data.records;
            }
            let { current, total, size } = data;
            this.liveRoomMore = this.liveRoomData.length < total;
            this.liveRoomPage = current;
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },
    liveRoomChange(e) {
      this.isLiveRoomInit = false;
    },
    courseTicketChange(e) {
      this.isCourseTicketInit = false;
    },
    changeLiveRoom(val) {
      console.log("-----changeLiveRoom---", val);
      let item = this.liveRoomData.filter((item) => item.uuid == val)[0];
      this.ruleForm.lecturerNamePost = item.lecturerFullName;
      this.ruleForm.bizStartTime = item.startDateStr;
      this.ruleForm.bizName = item.name;
    },
    changeCourseTicket(val) {
      console.log("-----changeCourseTicket---", val);
      let item = this.courseTicketData.filter((item) => item.uuid == val)[0];
      this.ruleForm.lecturerNamePost = item.lecturerFullName;
      this.ruleForm.bizStartTime = item.startDateStr;
      this.ruleForm.bizName = item.name;
    },
    getCourseTicketData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getCourseTicketSelectPage({ page, name: keyword })
          .then(({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.courseTicketData = [
                ...this.courseTicketData,
                ...data.records,
              ];
            } else {
              this.courseTicketData = data.records;
            }
            let { current, total, size } = data;
            this.courseTicketMore = this.courseTicketData.length < total;
            this.courseTicketPage = current;
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // this.typeList = res.data["CLIENT_TYPE_BANNER"];
        this.publicData = res.data["IS_VALID"] || [];
        this.popupBiztypeList = res.data["POPUP_BIZ_TYPE"] || [];
        if (!this.$route.query.id) {
          this.ruleForm.bizType = Number(this.popupBiztypeList[0].paramKey);
          this.ruleForm.isCountdown = Number(this.publicData[1].paramKey);
        }
      });
    },

    getPopupDetail(id) {
      getPopupInfo(id).then((res) => {
        if (!res || res.code != 0) return;
        const { data = {} } = res;
        const form = {
          ...data,
          popupDate: [data.popupStartDate, data.popupEndDate],
        };

        this.ruleForm = form;
        this.resetForm = JSON.parse(JSON.stringify(form));
      });
    },
    /**
     * 弹窗提醒时间变更
     */
    dateChange(val) {
      this.ruleForm.popupDate = val;
      if (val && val.length > 1) {
        this.ruleForm.popupStartDate = val[0];
        this.ruleForm.popupEndDate = val[1];
      }
    },
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (!this.ruleForm.coverUrl) {
          this.showError = true;
        }

        if (valid) {
          this.$confirm(`确认提交吗？`, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let params = { ...this.ruleForm };
              delete params["popupDate"];
              delete params["streamingAddress"];
              delete params["streamingCode"];
              delete params["streamingSumAddress"];
              if (this.editFlag) {
                updatePopupInfo(params).then((res) => {
                  if (!res || res.code != 0) return;
                  setItem(this.REFRESH_FLAG, true);
                  this.$message.success(res.msg);
                  this.goBack();
                  this.$refs["ruleForm"].resetFields();
                });
              } else {
                savePopupInfo(params).then((res) => {
                  if (!res || res.code != 0) return;
                  setItem(this.REFRESH_FLAG, true);
                  this.$message.success(res.msg);
                  this.goBack();
                  this.$refs["ruleForm"].resetFields();
                });
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$confirm(`确认重置表单吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.editFlag) {
            this.ruleForm = JSON.parse(JSON.stringify(this.resetForm));
          } else {
            Object.assign(this.$data.ruleForm, this.$options.data().ruleForm);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.tip_style {
  font-size: 1rem;
  float: left;
  height: 36px;
  line-height: 36px;
  background-color: #eee;
  padding: 0 6px;
  margin-top: 4px;
}
.add-title {
  display: flex;
  justify-content: space-between;
  .btn {
    margin-bottom: 6px;
  }
}
.text_left {
  width: calc(100% - 212px);
}
.text_right {
  margin-left: 12px;
  width: 200px;
  float: right;
}
.download_text {
  color: #3a85ff;
  // text-decoration: none;
}
.el-select__tags-text {
  font-size: 14px;
}

.autocomplete {
  width: 100%;
}

.el-autocomplete-suggestion {
  display: none;
}

.form-select {
  width: 100%;
}
/deep/ .el-range-editor--small.el-input__inner {
  width: 100%;
}
/deep/ .el-date-editor.el-input {
  width: 100%;
}
</style>
